<template>
  <transition name="fade">
    <div v-if="visible">
      <div class="charges-toolbar">
        <div class="toolbar-left-wrap">
          <div class="toolbar-left">
            <div
              v-for="({
                label,
                variant = 'green',
                onClick,
              }) in leftButtons"
              :key="label"
              class="left-option"
              @click="onClick"
            >
              <BfButton
                :variant="variant"
                class="left-button"
              >
                {{label}}
              </BfButton>
            </div>
          </div>
        </div>

        <div class="toolbar-right">
          <slot name="right-buttons"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable max-len */

export default {
  name: 'ChargesToolbar',

  props: {
    leftButtons: {
      type: Array,
      default: () => [],
    },

    visible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.charges-toolbar {
  z-index: 4;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 80px;
  height: 60px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.1);
  display: flex;
}

.toolbar-left-wrap {
  flex: 1;
  min-width: 0;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
  }

  &::before {
    left: 0;
    width: 20px;

    background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 );
  }

  &::after {
    right: 0;
    width: 50px;
    /* eslint-disable */
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 );
    /* eslint-enable */
  }
}

.toolbar-left {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;
  white-space: nowrap;
  overflow: scroll;
  padding: 10px 20px;

  .left-option {
    margin-right: 15px;

    .left-button {
      white-space: nowrap;
    }
  }

  // "Hack" to allow right-padding in the overflow container
  &::after {
    content: '';
    display: block;
    flex: 0 0 50px;
    height: 100%;
  }
}

.toolbar-right {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px 20px 5px 10px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 1px;
    height: 80%;
    top: 10%;
    left: 0;
    background: #cfcbcb;
  }

  &:empty {
    display: none;
  }
}

// Transitions
.fade-enter-active,
.fade-leave-active {
  .charges-toolbar {
    transition: opacity 0.25s ease, transform 0.25s ease-in-out;
  }
}

.fade-enter,
.fade-leave-to {
  .charges-toolbar {
    opacity: 0;
    transform: translateY(25%);
  }
}
</style>
